import { Component, OnInit } from '@angular/core';
import { Budget } from '../../../models/budgets/budget';
import { BudgetFilter } from '../../../models/budgets/budget.filter';
import { APP_ROUTES } from '../../../contants/APP_ROUTES';
import { Row } from '../../../models/tables/row';
import { DateHelper } from '../../../helpers/DateHelper';
import { Helper } from '../../../helpers/Helper';
import { QUERY_PARAMS } from '../../../contants/QUERY_PARAMS';
import { PARAMS } from '../../../contants/PARAMS';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../../services/common.service';
import { ParameterService } from '../../../services/parameter.service';
import { AlertService } from '../../../services/alert.service';
import { BudgetService } from '../../../services/budget.service';
import { PageOption } from '../../../models/common/pageOption';
import { BUDGET_TYPES } from '../../../contants/BUDGET_TYPES';
import { environment } from '../../../../environments/environment';

@Component({
	selector: 'app-budget-list',
	templateUrl: './budget-list.component.html',
	styleUrls: ['./budget-list.component.css']
})
export class BudgetListComponent implements OnInit {

	pageOption: PageOption<BudgetFilter> = new PageOption();
	
	rows: Row<Budget>[] = [];	

	constructor(
		private _budgetService: BudgetService,
		private _alertService: AlertService,
		private _parameterService: ParameterService,
		private _commonService: CommonService,
		private _router: Router,
		private _activatedRoute: ActivatedRoute
	) { }

	ngOnInit() {
		this.pageOption.searchFilter = new BudgetFilter();

		this._activatedRoute.queryParams.subscribe(
			params => {
				var filter = new BudgetFilter();
				if(params[QUERY_PARAMS.IS_DATE_NOW] != 'false'){
					filter.createdDate = DateHelper.getDateNowString();
				}

				this._parameterService.getCachedParameter<number>(PARAMS.BUDGET_TABLE_DEFAULT_PAGE_SIZE, 3600).subscribe(
					value => {
						value = Number(value);
						this.pageOption.pageSize = isNaN(value) || value == 0 ? 50 : value;
						this.pageOption.pageNumber = 1;
		
						this.search(filter);
					}
				);
			}
		);
	}

	fetchData(){
		this._budgetService.getBudgetList(this.pageOption).subscribe(
			result => {
				if (result.data != undefined) {
					if(this.pageOption.pageTotal <= 0){
						this.pageOption.pageTotal = result.totalPages;
					}

					let index = ((result.pageNumber - 1) * this.pageOption.pageSize);
					result.data.forEach(x => {
						let row = new Row<Budget>();
						row.status = 'loaded';
						row.object = x;
						this.rows[index] = row;
						index++;
					});
				}
			}
		);
	}

	onFetchNextData(pageNumber: number){
		this.pageOption.pageNumber = pageNumber;
		this.fetchData();
	}

	saveRow(index: number) {
		let budget = this.rows[index].object;

		if (budget.id == undefined || budget.id == 0) {
			this.createBudget(index, budget);
		}
		else {
			this.updateBudget(index, budget);
		}
	}

	addRow() {
		let row = new Row<Budget>();
		row.status = 'new';
		row.object = new Budget();
		row.object.id = 0;
		row.object.dateRecieved = DateHelper.getDateNowString();
		row.object.releasedById = Helper.currentUserId();
        row.object.createdDate = DateHelper.getDateNowString();
		row.object.recieverId = environment.budget_defaultRecieverId;
        row.object.type = BUDGET_TYPES[0];

		this.rows.push(row);
	}

	removeRow(index: number){
		let id = this.rows[index].object.id;
		this.rows.splice(index, 1);

		//call delete
		if(id != 0){
			this._budgetService.deleteBudget(id).subscribe(
				result => {
					if(result == undefined){
						this._alertService.showGenericError();
					}
					else if(result.errors.length > 0){
						this._alertService.displayErrorResult(result);
					}
				}
			);
		}
	}

	goToFormView(id: number){
		this._router.navigate([APP_ROUTES.budgetForm.replace('/:id', ''), id]);
	}

	search(filter: BudgetFilter) {
		if(filter != null){
			this.pageOption.searchFilter.dateRecieved = filter.dateRecieved;
			this.pageOption.searchFilter.recieverId = filter.recieverId;
			this.pageOption.searchFilter.releasedById = filter.releasedById;
			this.pageOption.searchFilter.createdDate = filter.createdDate; //date filed
			this.pageOption.searchFilter.createdBy = filter.createdBy;
			this.pageOption.searchFilter.updatedDate = filter.updatedDate;
			this.pageOption.searchFilter.updatedBy = filter.updatedBy;
		}

		this.rows = []; //reset array
		this.fetchData();
	}

	private createBudget(index: number, newBudget: Budget) {
		this._budgetService.addBudget(newBudget).subscribe(result => {
			if (result.object != undefined) {
				this.updateObject(index, result.object);
				this._alertService.showSuccess('Cash Advance information has been saved.')
			}
			else {
				this.rows[index].hasError = true;
				this._alertService.displayErrorResult(result.errorCollection);
			}
		});
	}

	private updateBudget(index: number, existingBudget: Budget) {
		this._budgetService.updateBudget(existingBudget).subscribe(result => {
			if (result.object != undefined) {
				this.updateObject(index, result.object);
				this._alertService.showSuccess('Cash Advance information has been updated.');
			}
			else {
				this.rows[index].hasError = true;
				this._alertService.displayErrorResult(result.errorCollection);
			}
		});
	}

	private updateObject(index: number, object: Budget){
		this.rows[index].object = object;
		this.rows[index].hasError = false;
	}

	getTotal(){
		let totalAmount = 0;
		this.rows.forEach(row => {
			let value = Number(row.object.amount);
			totalAmount += isNaN(value) ? 0 : value;
		})

		return totalAmount;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/budgets/budget-list/budget-list.component.ts